<!-- Custom spinner overlay -->
<div *ngIf="currentStateService.showLoading$ | async" class="custom-spinner-overlay">
  <div class="custom-spinner"></div>
</div>

<!-- Report generation progress bar -->
<div *ngIf="currentStateService.reportGenerationProgress$ | async" class="progress-overlay">
  <div class="progress-container">
    <h3>{{ 'REPORT.GENERATING' | translate }}</h3>
    <div class="progress-bar-wrapper">
      <div class="progress-bar-animated"></div>
    </div>
  </div>
</div>

<main id="main" class="main-content">

  <div id="box-nav-bar-left" *ngIf="shouldShowLeftBar()">
    <app-nav-bar-left />
  </div>

  <div id="center">
    <div id="box-nav-bar-top" *ngIf="shouldShowNavBarTop()">
      <app-nav-bar-top />
    </div>

    <div id="box-carte">
      <router-outlet></router-outlet>

    </div>
    
  </div>
  
</main>